import { Component, OnInit, NgZone, HostListener } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

import { UsuarioService } from '../../../services/usuario.service';
import { ServicoService } from '../../../services/servico.service';
import { forkJoin, of, Observable } from 'rxjs';
import { map, switchMap, catchError, delay } from 'rxjs/operators';
import { OrdemServicoService } from '../../../services/ordemSerico.service';
import { AuthService } from '../../../../../services/auth.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-ordem-servico',
  standalone: false,
  templateUrl: './ordem-servico.component.html',
  styleUrls: ['./ordem-servico.component.css']
})
export class OrdemServicoComponent implements OnInit {
  ordens: any[] = [];
  // seleção em massa
  selectedOrdens: Set<string> = new Set<string>();
  selectedOrdemFoto: any = null;
  showReatribuirBatchModal = false;
  showDesatribuirBatchModal = false;
  selectedColaboradorIdBatch: string | null = null;
  loading = false;
  error = '';
  showFiltros: boolean = false;
  // filtros para UI
  filtroDataInicio: string | null = null;
  filtroDataFim: string | null = null;
  filtroStatus: string = '';
  filtroUsuarioId: string | null = null;
  filtroNumeroOrdem: number | null = null;
  filtroMatricula: string | null = null;
  filtroNomeConsumidor: string | null = null;
  // novos filtros (parciais compatíveis com a página de Servicos)
  filtroCpf: string | null = null;
  filtroCnpj: string | null = null;
  filtroCep: string | null = null;
  filtroLogradouro: string | null = null;
  filtroBairro: string | null = null;
  filtroCidade: string | null = null;
  filtroEstado: string | null = null;
  filtroNumero: string | null = null;
  // paginação
  paginaAtual = 1;
  tamanhoPagina = 50;
  totalItens = 0;
  totalPaginas = 0;
  usuariosMap: { [usuarioId: string]: any } = {};

  actionLoading: { [ordemId: string]: boolean } = {};

  viewLoading: { [ordemId: string]: boolean } = {};

  showCancelModal = false;
  cancelingOrder: any = null;
  currentUserRole: string = '';

  get isSuperAdministrador(): boolean {
    return (this.currentUserRole || '').toString().trim() === 'SuperAdministrador';
  }

  constructor(
    private ordemServicoService: OrdemServicoService,
    private usuarioService: UsuarioService
    , private ngZone: NgZone,
    private router: Router,
    private servicoService: ServicoService,
    private spinner: NgxSpinnerService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {

    // Normalize role so template equality checks work regardless of casing/whitespace
    const rawRole = this.authService.getUserRoleSync() || '';
    const r = (rawRole || '').toString().trim().toLowerCase();
    if (r === 'superadministrador' || r === 'super admin' || r === 'super_administrador') {
      this.currentUserRole = 'SuperAdministrador';
    } else if (r === 'administrador' || r === 'admin') {
      this.currentUserRole = 'Administrador';
    } else {
      // fallback: keep trimmed original (helps debugging if unexpected value)
      this.currentUserRole = (rawRole || '').toString().trim();
    }

    this.loading = true;
    // Carregar colaboradores para o filtro de vistoriante
    this.carregandoColaboradores = true;
    this.usuarioService.carregarTodosColaboradores().subscribe(list => {
      this.colaboradores = list || [];
      this.carregandoColaboradores = false;
    }, () => {
      this.colaboradores = [];
      this.carregandoColaboradores = false;
    });

    // Restaurar filtro de período do localStorage, se existir
    const periodoSalvo = localStorage.getItem('filtroPeriodoOrdemServico');
    if (periodoSalvo) {
      try {
        const periodo = JSON.parse(periodoSalvo);
        this.filtroDataInicio = periodo.inicio || this.getDataHojeInput();
        this.filtroDataFim = periodo.fim || this.getDataHojeInput();
      } catch {
        this.filtroDataInicio = this.getDataHojeInput();
        this.filtroDataFim = this.getDataHojeInput();
      }
    } else {
      this.filtroDataInicio = this.getDataHojeInput();
      this.filtroDataFim = this.getDataHojeInput();
    }

      // Restaurar pagina e tamanho da página do localStorage, se existir
      try {
        const paginaSalva = localStorage.getItem('filtroPaginaOrdemServico');
        const tamanhoSalvo = localStorage.getItem('filtroTamanhoPaginaOrdemServico');
        if (tamanhoSalvo) {
          const parsed = Number(tamanhoSalvo);
          if (!isNaN(parsed) && parsed > 0) {
            this.tamanhoPagina = parsed;
          }
        }
        if (paginaSalva) {
          const parsedP = Number(paginaSalva);
          if (!isNaN(parsedP) && parsedP > 0) {
            this.paginaAtual = parsedP;
          }
        }
      } catch (e) {
        // ignore localStorage errors (e.g., disabled)
      }

    // Busca inicial de todas as ordens
    this.loadPage();

  }

  // seleção em massa helpers
  toggleSelectOrdem(ordem: any, event?: Event) {
    event?.stopPropagation();
    if (!ordem || !ordem.ordemServicoId) return;
    if (this.selectedOrdens.has(ordem.ordemServicoId)) {
      this.selectedOrdens.delete(ordem.ordemServicoId);
    } else {
      this.selectedOrdens.add(ordem.ordemServicoId);
    }
  }

  clearSelection() {
    this.selectedOrdens.clear();
  }

  get selectedCount(): number { return this.selectedOrdens.size; }

  selectAllToggle(event?: Event) {
    event?.stopPropagation();
    if (!this.ordens || this.ordens.length === 0) return;
    if (this.selectedCount === this.ordens.length) {
      this.clearSelection();
      return;
    }
    this.ordens.forEach(o => { if (o && o.ordemServicoId) this.selectedOrdens.add(o.ordemServicoId); });
  }

  // verifica se todas as ordens selecionadas possuem status em lista permitida
  allSelectedHaveStatusIn(list: string[]): boolean {
    if (this.selectedOrdens.size === 0) return false;
    for (const id of Array.from(this.selectedOrdens)) {
      const o = this.ordens.find(x => x.ordemServicoId === id);
      if (!o) return false;
      if (!list.includes(o.status)) return false;
    }
    return true;
  }

  // Abre modal batch reatribuir
  openReatribuirBatchModal() {
    if (!this.allSelectedHaveStatusIn(['Pendente','Retornar','Concluida','Negada'])) {
      alert('Selecione apenas ordens com status Pendente, Retornar, Concluída ou Negada para reatribuir em lote.');
      return;
    }
    this.selectedColaboradorIdBatch = null;
    this.showReatribuirBatchModal = true;
    if (!this.colaboradores || this.colaboradores.length === 0) {
      this.carregandoColaboradores = true;
      this.usuarioService.carregarTodosColaboradores().subscribe(list => { this.colaboradores = list || []; this.carregandoColaboradores = false; }, () => { this.colaboradores = []; this.carregandoColaboradores = false; });
    }
  }

  closeReatribuirBatchModal() {
    this.showReatribuirBatchModal = false;
    this.selectedColaboradorIdBatch = null;
  }

  confirmReatribuirBatch() {
    if (!this.selectedColaboradorIdBatch) { alert('Selecione um vistoriante.'); return; }
    const novoUsuarioId: string = this.selectedColaboradorIdBatch as string;
    const ids = Array.from(this.selectedOrdens);
    if (ids.length === 0) return;
    this.spinner.show();
    this.actionLoading = this.actionLoading || {};

    const tasks = ids.map(id => {
      const ordem = this.ordens.find(o => o.ordemServicoId === id);
      if (ordem && ordem.status === 'Retornar') {
        // Para status Retornar, distribui direto
        const cadastroId = ordem.cadastroId ?? ordem.CadastroId ?? ordem.Cadastro?.id ?? ordem.CadastroId;
        const recadastroId = ordem.recadastroId ?? ordem.RecadastroId ?? ordem.Recadastro?.id ?? ordem.recadastroId;
        const ordemServicoId = ordem.ordemServicoId ?? ordem.OrdemServicoId ?? ordem.OrdemServicoID ?? ordem.id;
        const matricula = ordem.matricula ?? ordem.Matricula ?? ordem.cadastroMatricula ?? ordem.Cadastro?.matricula ?? ordem.Cadastro?.Matricula ?? ordem.CadastroId ?? '-';
        const status = ordem.status ?? ordem.Status ?? '';
        const statusOS = ordem.statusOS ?? ordem.StatusOS ?? ordem.status_os ?? '';
        return this.ordemServicoService.distribuirOrdemServico(
          novoUsuarioId,
          cadastroId,
          recadastroId,
          ordemServicoId,
          matricula,
          status,
          statusOS
        );
      } else if (ordem && (ordem.status === 'Negada' || ordem.status === 'Concluida')) {
        // Para Negada/Concluida, primeiro atualiza para Retornar, depois distribui
        const cadastroId = ordem.cadastroId ?? ordem.CadastroId ?? ordem.Cadastro?.id ?? ordem.CadastroId;
        const recadastroId = ordem.recadastroId ?? ordem.RecadastroId ?? ordem.Recadastro?.id ?? ordem.recadastroId;
        const ordemServicoId = ordem.ordemServicoId ?? ordem.OrdemServicoId ?? ordem.OrdemServicoID ?? ordem.id;
        const matricula = ordem.matricula ?? ordem.Matricula ?? ordem.cadastroMatricula ?? ordem.Cadastro?.matricula ?? ordem.Cadastro?.Matricula ?? ordem.CadastroId ?? '-';
        const statusOS = ordem.statusOS ?? ordem.StatusOS ?? ordem.status_os ?? '';
        // Atualiza status para Retornar e depois distribui
        return this.ordemServicoService.changeStatus(ordemServicoId, 4).pipe(
          switchMap(() => this.ordemServicoService.distribuirOrdemServico(
            novoUsuarioId,
            cadastroId,
            recadastroId,
            ordemServicoId,
            matricula,
            'Retornar',
            statusOS
          ))
        );
      } else {
        // Para outros status, usar reatribuirOrdemServico
        return this.ordemServicoService.reatribuirOrdemServico(id, novoUsuarioId);
      }
    });

    forkJoin(tasks).subscribe(results => {
      this.spinner.hide();
      // atualizar UI localmente
      ids.forEach(id => {
        const idx = this.ordens.findIndex(o => o.ordemServicoId === id);
        if (idx >= 0) {
          this.ordens[idx].usuarioId = novoUsuarioId;
          // se estava Retornar, atualizamos para Pendente por regra
          if (this.ordens[idx].status === 'Retornar') this.ordens[idx].status = 'Pendente';
          else this.ordens[idx].status = 'Pendente';
        }
      });
      this.buscarUsuariosParaOrdens(this.ordens.filter(o => ids.includes(o.ordemServicoId)));
      this.clearSelection();
      this.closeReatribuirBatchModal();
    }, err => {
      this.spinner.hide();
      alert('Erro ao reatribuir ordens selecionadas. Veja console.');
      console.error(err);
    });
  }

  // Batch desatribuir
  openDesatribuirBatchModal() {
    if (!this.isSuperAdministrador) {
      alert('Apenas usuários com role SuperAdministrador podem desatribuir ordens em lote.');
      return;
    }
    if (!this.allSelectedHaveStatusIn(['Pendente','Retornar'])) {
      alert('Selecione apenas ordens com status Pendente ou Retornar para desatribuir em lote.');
      return;
    }
    this.showDesatribuirBatchModal = true;
  }

  closeDesatribuirBatchModal() {
    this.showDesatribuirBatchModal = false;
  }

  confirmDesatribuirBatch() {
    const ids = Array.from(this.selectedOrdens);
    if (ids.length === 0) return;
    this.spinner.show();
    const tasks = ids.map(id => this.ordemServicoService.desatribuirOrdemServico(id));
    forkJoin(tasks).subscribe(res => {
      this.spinner.hide();
      // reload page to ensure consistent state
      this.clearSelection();
      this.closeDesatribuirBatchModal();
      this.loadPage(this.paginaAtual);
    }, err => {
      this.spinner.hide();
      alert('Erro ao desatribuir ordens selecionadas. Veja console.');
      console.error(err);
    });
  }

  getDataHojeInput(): string {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  getDataSeteDiasAtrasInput(): string {
    const d = new Date();
    d.setDate(d.getDate() - 6); // inclusive last 7 days (today and 6 previous days)
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  onDataFimChange(): void {
    if (this.filtroDataFim) {
      // Salvar filtro de período no localStorage
      localStorage.setItem('filtroPeriodoOrdemServico', JSON.stringify({
        inicio: this.filtroDataInicio,
        fim: this.filtroDataFim
      }));
      this.paginaAtual = 1;
      this.aplicarFiltros();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target) return;
    const menuBtn = target.closest('.action-menu-wrapper');
    if (menuBtn) return;
    // fecha todos
    (this.ordens || []).forEach(o => { if (o && o._actionMenuOpen) o._actionMenuOpen = false; });
  }

  private buscarUsuariosParaOrdens(ordens: any[]): void {
    const usuarioIds = ordens
      .map(o => o.usuarioId ?? o.UsuarioId)
      .filter(id => !!id &&
        id !== '00000000-0000-0000-0000-000000000000' &&
        !this.usuariosMap[id]
      );
    if (usuarioIds.length === 0) return;
    forkJoin(
      usuarioIds.map(id =>
        this.usuarioService.getUsuarioById(id)
      )
    ).subscribe((usuarios) => {
      usuarios.forEach((usuario, idx) => {
        const alt = (usuario as any)?.UsuarioId ?? (usuario as any)?.id;
        const key = (usuario as any)?.usuarioId ?? alt;
        if (usuario && key) {
          this.usuariosMap[key] = usuario;
        }
      });
    });
  }

  // Carrega página de ordens com filtros aplicados
  loadPage(page: number = this.paginaAtual): void {
    this.loading = true;
    this.paginaAtual = page;

      // persist current page to localStorage so when user returns it's restored
      try {
        localStorage.setItem('filtroPaginaOrdemServico', String(this.paginaAtual));
        localStorage.setItem('filtroTamanhoPaginaOrdemServico', String(this.tamanhoPagina));
      } catch (e) {
        // ignore storage errors
      }

    // Converter status string para número se necessário
    let statusNumber: number | undefined = undefined;
    if (this.filtroStatus) {
      switch (this.filtroStatus) {
        case 'Pendente': statusNumber = 0; break;
        case 'EmAndamento': statusNumber = 1; break;
        case 'Concluida': statusNumber = 2; break;
        case 'Cancelada': statusNumber = 3; break;
        case 'Retornar': statusNumber = 4; break;
        case 'Negada': statusNumber = 5; break;
      }
    }

    this.ordemServicoService.getOrdensServico(
      this.filtroDataInicio || undefined,
      this.filtroDataFim || undefined,
      statusNumber,
      this.filtroNumeroOrdem || undefined,
      this.filtroMatricula || undefined,
      this.filtroNomeConsumidor || undefined,
      this.filtroUsuarioId || undefined,
      this.filtroCpf || undefined,
      this.filtroCnpj || undefined,
      this.filtroCep || undefined,
      this.filtroLogradouro || undefined,
      this.filtroBairro || undefined,
      this.filtroCidade || undefined,
      this.filtroEstado || undefined,
      this.filtroNumero || undefined,
      this.paginaAtual,
      this.tamanhoPagina
    ).subscribe({
      next: (res) => {
        if (res) {
          // a API pode retornar um array direto ou um objeto com propriedade itens
          const itens = Array.isArray(res) ? res : (res && res.itens ? res.itens : []);
          const normalized = itens.map((r: any) => this.normalizeOrdem(r));
          this.ordens = normalized;
          this.totalItens = res.totalItens || normalized.length;
          this.totalPaginas = res.totalPaginas || Math.ceil(this.totalItens / this.tamanhoPagina);
          this.buscarUsuariosParaOrdens(this.ordens);
        } else {
          this.ordens = [];
          this.totalItens = 0;
          this.totalPaginas = 0;
        }
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Erro ao buscar as vistorias.';
        this.loading = false;
      }
    });
  }

  aplicarFiltros(): void {
    // reset to first page and reload
    this.paginaAtual = 1;
    this.showFiltros = false;
    // Salvar filtro de período no localStorage
    localStorage.setItem('filtroPeriodoOrdemServico', JSON.stringify({
      inicio: this.filtroDataInicio,
      fim: this.filtroDataFim
    }));
    // If filtroUsuarioId set but colaboradores not loaded, try to pre-load colaboradores
    if (this.filtroUsuarioId && (!this.colaboradores || this.colaboradores.length === 0)) {
      this.carregandoColaboradores = true;
      this.usuarioService.carregarTodosColaboradores().subscribe(list => {
        this.colaboradores = list || [];
        this.carregandoColaboradores = false;
        this.loadPage(1);
      }, () => {
        this.colaboradores = [];
        this.carregandoColaboradores = false;
        this.loadPage(1);
      });
      return;
    }
    this.loadPage(1);
  }

  resetFiltros(): void {
    this.filtroDataInicio = null;
    this.filtroDataFim = null;
    // Limpar filtro salvo no localStorage
    localStorage.removeItem('filtroPeriodoOrdemServico');
    this.filtroStatus = '';
    this.filtroUsuarioId = null;
    this.filtroNumeroOrdem = null;
    this.filtroMatricula = null;
    this.filtroNomeConsumidor = null;
    // reset novos filtros
    this.filtroCpf = null;
    this.filtroCnpj = null;
    this.filtroCep = null;
    this.filtroLogradouro = null;
    this.filtroBairro = null;
    this.filtroCidade = null;
    this.filtroEstado = null;
    this.filtroNumero = null;
    this.showFiltros = false;
    this.loadPage(1);
  }

  // compatibilidade com templates que usam nomes em português
  proximaPagina(): void { if (this.paginaAtual < this.totalPaginas) this.loadPage(this.paginaAtual + 1); }
  paginaAnterior(): void { if (this.paginaAtual > 1) this.loadPage(this.paginaAtual - 1); }

  alterarTamanhoPagina(novoTamanho: number): void {
    const parsed = Number(novoTamanho) || this.tamanhoPagina;
    this.tamanhoPagina = parsed;
      // persist tamanho da página
      try {
        localStorage.setItem('filtroTamanhoPaginaOrdemServico', String(this.tamanhoPagina));
        // reset to first page when page size changes
        localStorage.setItem('filtroPaginaOrdemServico', '1');
      } catch (e) {}
      this.loadPage(1);
  }

  // Paginação simples
  nextPage(): void { if (this.paginaAtual < this.totalPaginas) this.loadPage(this.paginaAtual + 1); }
  prevPage(): void { if (this.paginaAtual > 1) this.loadPage(this.paginaAtual - 1); }

  // Converte diferentes formatos do payload para o shape que o template espera
  private normalizeOrdem(raw: any): any {
    if (!raw) return raw;
    const ordemServicoId = raw.ordemServicoId ?? raw.OrdemServicoId ?? raw.OrdemServicoID ?? raw.id;
    const usuarioId = raw.usuarioId ?? raw.UsuarioId ?? (raw.Usuario && (raw.Usuario.usuarioId ?? raw.Usuario.id)) ?? null;
    const dataDistribuicao = raw.dataDistribuicao ?? raw.DataDistribuicao ?? raw.DataDeDistribuicao ?? null;

    // mapa de status numérico para texto (ajuste caso seu enum seja diferente)
    const status = this.mapStatus(raw.status ?? raw.Status ?? raw.StatusCode ?? raw.StatusEnum);

    // matrícula / nome — procura em várias posições (direct / Cadastro)
    const matricula = raw.matricula ?? raw.Matricula ?? raw.cadastroMatricula ?? raw.Cadastro?.matricula ?? raw.Cadastro?.Matricula ?? raw.CadastroId ?? '-';
    const nomeConsumidor = raw.nomeConsumidor ?? raw.NomeConsumidor ?? raw.nome ?? raw.Nome ?? raw.Cadastro?.nome ?? raw.Cadastro?.Nome ?? raw.consumidorNome ?? '-';

    // número da ordem
    const numeroOrdem = raw.numeroOrdem ?? raw.NumeroOrdem ?? raw.NumeroDeOrdem ?? null;
    const numeroOrdemFormatado = raw.numeroOrdemFormatado ?? raw.NumeroOrdemFormatado ?? null;

    // endereço — tenta montar um objeto com as chaves usadas no template
    const enderecoSrc = raw.endereco ?? raw.Endereco ?? raw.Cadastro?.endereco ?? raw.Cadastro?.Endereco ?? null;
    const endereco = enderecoSrc ? {
      logradouro: enderecoSrc.logradouro ?? enderecoSrc.Logradouro ?? enderecoSrc.street ?? null,
      bairro: enderecoSrc.bairro ?? enderecoSrc.Bairro ?? enderecoSrc.neighborhood ?? null,
      localidade: enderecoSrc.localidade ?? enderecoSrc.localidade ?? enderecoSrc.cidade ?? enderecoSrc.Cidade ?? null,
      cep: enderecoSrc.cep ?? enderecoSrc.CEP ?? enderecoSrc.cep ?? null
    } : null;

    return {
      ...raw,
      ordemServicoId,
      usuarioId,
      dataDistribuicao,
      status,
      matricula,
      nomeConsumidor,
      numeroOrdem,
      numeroOrdemFormatado,
      endereco
    };
  }

  private mapStatus(status: any): string {
    if (status === null || status === undefined) return null as any;
    // se número, mapear para rótulos conhecidos
    if (typeof status === 'number') {
      switch (status) {
        case 0: return 'Pendente';
        case 1: return 'EmAndamento';
        case 2: return 'Concluida';
        case 3: return 'Cancelada';
        case 4: return 'Pendente';
        case 5: return 'Negada';
        default: return String(status);
      }
    }
    // se string já legível, apenas normaliza possiveis PascalCase
    const s = String(status);
    if (s.toLowerCase() === 'pendente') return 'Pendente';
    if (s.toLowerCase().includes('andamento')) return 'EmAndamento';
    if (s.toLowerCase().includes('conclu')) return 'Concluida';
    // if (s.toLowerCase().includes('reatribu')) return 'Reatribuida';
    if (s.toLowerCase().includes('cancel')) return 'Cancelada';
    if (s.toLowerCase().includes('negada')) return 'Negada';
    return s;
  }

  // Helper: mapeia string de status para código usado pelo endpoint de ordem (aproximação)
  private statusStringToCode(statusStr: string): number {
    if (!statusStr) return 0;
    const s = String(statusStr).toLowerCase();
    if (s === 'pendente') return 0;
    if (s.includes('andamento')) return 1;
    if (s.includes('conclu')) return 2;
    if (s.includes('cancel')) return 3;
    // 'ausente' / 'retornar' -> manter como Pendente na ordem (reatribuição/retorno trata cadastro como Ausente)
    if (s === 'ausente' || s === 'retornar') return 0;
    if (s.includes('negad')) return 5;
    return 0;
  }

  // Ensure order status is applied after recadastro/cadastro changes. Retries if backend overrides it.
  private applyOrderStatusWithRetries(ordemId: string, statusCode: number, desiredText: string, retries: number = 3, delayMs: number = 2000): Observable<any> {

    return this.ordemServicoService.changeStatus(ordemId, statusCode).pipe(
      switchMap(res => {

        return of(null).pipe(delay(delayMs), switchMap(() => this.ordemServicoService.getOrdemServicoById(ordemId)));
      }),
      switchMap((ord: any) => {
        const current = this.mapStatus(ord?.status ?? ord?.Status ?? ord?.StatusCode ?? ord?.StatusEnum);
        if (current === desiredText || retries <= 0) {
          return of(ord);
        }
        return of(null).pipe(delay(delayMs), switchMap(() => this.applyOrderStatusWithRetries(ordemId, statusCode, desiredText, retries - 1, delayMs)));
      }),
      catchError(err => {
        console.error('[OrdemServico] applyOrderStatusWithRetries error', err);
        if (retries <= 0) return of(null);
        return of(null).pipe(delay(delayMs), switchMap(() => this.applyOrderStatusWithRetries(ordemId, statusCode, desiredText, retries - 1, delayMs)));
      })
    );
  }

  // Ações: cancelar, reatribuir e ver
  onCancelar(ordem: any): void {
    // abrir modal de confirmação em vez do prompt nativo
    if (!ordem || !ordem.ordemServicoId) return;
    this.cancelingOrder = ordem;
    this.showCancelModal = true;
  }

  openCancelModal(ordem: any) {
    if (!ordem || !ordem.ordemServicoId) return;
    this.cancelingOrder = ordem;
    this.showCancelModal = true;
  }

  closeCancelModal() {
    this.showCancelModal = false;
    this.cancelingOrder = null;
  }

  confirmCancel(): void {
    if (!this.cancelingOrder || !this.cancelingOrder.ordemServicoId) return;
    const id = this.cancelingOrder.ordemServicoId;
    this.actionLoading[id] = true;
    this.spinner.show();
    this.ordemServicoService.changeStatus(id, 3).subscribe(res => {
      this.actionLoading[id] = false;
      this.spinner.hide();
      this.showCancelModal = false;
      if (res) {
        const idx = this.ordens.findIndex(o => o.ordemServicoId === id);
        if (idx >= 0) this.ordens[idx] = { ...this.ordens[idx], status: 'Cancelada' };
      } else {
        alert('Falha ao cancelar a ordem.');
      }
      this.cancelingOrder = null;
    });
  }

  // Reatribuir: abrir modal com select de colaboradores
  showReatribuirModal = false;
  reatribuirOrder: any = null;
  colaboradores: any[] = [];
  selectedColaboradorId: string | null = null;
  carregandoColaboradores = false;

  // Desatribuir: abrir modal de confirmação
  showDesatribuirModal = false;
  desatribuirOrder: any = null;

  onReatribuir(ordem: any): void {
    if (!ordem || !ordem.ordemServicoId) return;
    this.reatribuirOrder = ordem;
    this.selectedColaboradorId = ordem.usuarioId ?? null;
    this.showReatribuirModal = true;
    // carregar colaboradores se ainda não tiver
    if (!this.colaboradores || this.colaboradores.length === 0) {
      this.carregandoColaboradores = true;
      this.usuarioService.carregarTodosColaboradores().subscribe(list => {
        this.colaboradores = list || [];
        this.carregandoColaboradores = false;
      }, () => {
        this.colaboradores = [];
        this.carregandoColaboradores = false;
      });
    }
  }

  onDesatribuir(ordem: any): void {
    if (!ordem || !ordem.ordemServicoId) return;
    // only allow desatribuir for orders still pending
    if ((ordem.status || '').toString() !== 'Pendente') {
      Swal.fire({
        icon: 'info',
        title: 'Ação inválida',
        text: 'Só é possível desatribuir ordens com status Pendente.'
      });
      return;
    }
    this.desatribuirOrder = ordem;
    this.showDesatribuirModal = true;
  }

  // Wrappers usados pelo menu de ações: fecham o popover com segurança e disparam a ação
  triggerCancelFromMenu(ordem: any, event?: Event) {
    event?.stopPropagation();
    if (!ordem) return;
    ordem._actionMenuOpen = false;
    // small delay to allow the popover to be removed from DOM and avoid focus issues
    setTimeout(() => this.openCancelModal(ordem), 50);
  }

  triggerReatribuirFromMenu(ordem: any, event?: Event) {
    event?.stopPropagation();
    if (!ordem) return;
    ordem._actionMenuOpen = false;
    setTimeout(() => this.onReatribuir(ordem), 50);
  }

  triggerDesatribuirFromMenu(ordem: any, event?: Event) {
    event?.stopPropagation();
    if (!ordem) return;
    ordem._actionMenuOpen = false;
    // guard: do not open if not pending
    if ((ordem.status || '').toString() !== 'Pendente') {
      setTimeout(() => {
        Swal.fire({
          icon: 'info',
          title: 'Ação inválida',
          text: 'Só é possível desatribuir ordens com status Pendente.'
        });
      }, 40);
      return;
    }
    setTimeout(() => this.onDesatribuir(ordem), 50);
  }

  triggerVerFromMenu(ordem: any, event?: Event) {
    event?.stopPropagation();
    if (!ordem) return;
    ordem._actionMenuOpen = false;
    // small delay ensures UI cleanup before navigation
    setTimeout(() => this.onVer(ordem), 60);
  }

  closeReatribuirModal() {
    this.showReatribuirModal = false;
    this.reatribuirOrder = null;
    this.selectedColaboradorId = null;
  }

  closeDesatribuirModal() {
    this.showDesatribuirModal = false;
    this.desatribuirOrder = null;
  }

  confirmReatribuir(): void {
    if (!this.reatribuirOrder || !this.reatribuirOrder.ordemServicoId) return;
    if (!this.selectedColaboradorId) {
      alert('Selecione um usuário para reatribuir.');
      return;
    }
    const id = this.reatribuirOrder.ordemServicoId;
    const novoUsuarioId: string = this.selectedColaboradorId as string;
    this.actionLoading[id] = true;
    this.spinner.show();
    const ordem = this.reatribuirOrder;
    let obs$;
    if (ordem && ordem.status === 'Retornar') {
      // Para status Retornar, distribui direto
      const cadastroId = ordem.cadastroId ?? ordem.CadastroId ?? ordem.Cadastro?.id ?? ordem.CadastroId;
      const recadastroId = ordem.recadastroId ?? ordem.RecadastroId ?? ordem.Recadastro?.id ?? ordem.recadastroId;
      const ordemServicoId = ordem.ordemServicoId ?? ordem.OrdemServicoId ?? ordem.OrdemServicoID ?? ordem.id;
      const matricula = ordem.matricula ?? ordem.Matricula ?? ordem.cadastroMatricula ?? ordem.Cadastro?.matricula ?? ordem.Cadastro?.Matricula ?? ordem.CadastroId ?? '-';
      const status = ordem.status ?? ordem.Status ?? '';
      const statusOS = ordem.statusOS ?? ordem.StatusOS ?? ordem.status_os ?? '';
      obs$ = this.ordemServicoService.distribuirOrdemServico(
        novoUsuarioId,
        cadastroId,
        recadastroId,
        ordemServicoId,
        matricula,
        status,
        statusOS
      );
    } else if (ordem && (ordem.status === 'Negada' || ordem.status === 'Concluida')) {
      // Para Negada/Concluida, primeiro atualiza para Retornar, depois distribui
      const cadastroId = ordem.cadastroId ?? ordem.CadastroId ?? ordem.Cadastro?.id ?? ordem.CadastroId;
      const recadastroId = ordem.recadastroId ?? ordem.RecadastroId ?? ordem.Recadastro?.id ?? ordem.recadastroId;
      const ordemServicoId = ordem.ordemServicoId ?? ordem.OrdemServicoId ?? ordem.OrdemServicoID ?? ordem.id;
      const matricula = ordem.matricula ?? ordem.Matricula ?? ordem.cadastroMatricula ?? ordem.Cadastro?.matricula ?? ordem.Cadastro?.Matricula ?? ordem.CadastroId ?? '-';
      const statusOS = ordem.statusOS ?? ordem.StatusOS ?? ordem.status_os ?? '';
      obs$ = this.ordemServicoService.changeStatus(ordemServicoId, 4).pipe(
        switchMap(() => this.ordemServicoService.distribuirOrdemServico(
          novoUsuarioId,
          cadastroId,
          recadastroId,
          ordemServicoId,
          matricula,
          'Retornar',
          statusOS
        ))
      );
    } else {
      // Para outros status, usar reatribuirOrdemServico
      obs$ = this.ordemServicoService.reatribuirOrdemServico(id, novoUsuarioId);
    }
    obs$.subscribe(res => {
      this.actionLoading[id] = false;
      this.spinner.hide();
      this.showReatribuirModal = false;
      if (res) {
        const idx = this.ordens.findIndex(o => o.ordemServicoId === id);
        // após reatribuir, se status era 'Retornar' devemos também atualizar cadastro/recadastro para 'Pendente'
        if (idx >= 0) {
          const original = this.reatribuirOrder || this.ordens[idx];
          const cadastroId = original.cadastroId ?? original.CadastroId ?? original.Cadastro?.id ?? original.CadastroId;
          const recadastroId = original.recadastroId ?? original.RecadastroId ?? original.Recadastro?.id ?? original.recadastroId;
          if (original && ['Retornar', 'Negada', 'Concluida'].includes(original.status)) {
            if (recadastroId) {
              // first update recadastro, then update OS status
              this.servicoService.atualizarStatusRecadastro(recadastroId, 'Pendente', undefined, undefined)
                .pipe(
                  switchMap(() => this.ordemServicoService.changeStatus(id, 0)),
                  catchError(() => this.ordemServicoService.changeStatus(id, 0))
                )
                .subscribe(() => { /* ok */ }, () => { /* ignore */ });
            } else if (cadastroId) {
              this.servicoService.atualizarStatusCadastro(cadastroId, 'Pendente', undefined, undefined)
                .pipe(
                  switchMap(() => this.ordemServicoService.changeStatus(id, 0)),
                  catchError(() => this.ordemServicoService.changeStatus(id, 0))
                )
                .subscribe(() => { /* ok */ }, () => { /* ignore */ });
            } else {
              // fallback to ordem status update if no cadastro/recadastro id
              this.ordemServicoService.changeStatus(id, 0).subscribe(() => {/* noop */}, () => {/* noop */});
            }
          }
          // update local view
          this.ordens[idx] = { ...this.ordens[idx], status: 'Pendente', usuarioId: novoUsuarioId };
        }
        // atualizar info do usuario
        this.buscarUsuariosParaOrdens([this.ordens[idx]]);
      } else {
        alert('Falha ao reatribuir a ordem.');
      }
      this.reatribuirOrder = null;
      this.selectedColaboradorId = null;
    });
  }

  confirmDesatribuir(): void {
    if (!this.desatribuirOrder || !this.desatribuirOrder.ordemServicoId) return;
    if ((this.desatribuirOrder.status || '').toString() !== 'Pendente') {
      Swal.fire({
        icon: 'info',
        title: 'Ação inválida',
        text: 'Só é possível desatribuir ordens com status Pendente.'
      });
      this.closeDesatribuirModal();
      this.desatribuirOrder = null;
      return;
    }
    const id = this.desatribuirOrder.ordemServicoId;
    this.actionLoading[id] = true;
    this.spinner.show();
    this.ordemServicoService.desatribuirOrdemServico(id).subscribe(res => {
      this.actionLoading[id] = false;
      this.spinner.hide();
      this.showDesatribuirModal = false;
      if (res) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Ordem desatribuída com sucesso. O vistoriante foi removido.',
          confirmButtonText: 'OK'
        });
        this.closeDesatribuirModal();
        this.loadPage(this.paginaAtual);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao desatribuir a ordem.',
          confirmButtonText: 'OK'
        });
      }
      this.desatribuirOrder = null;
    }, err => {
      this.actionLoading[id] = false;
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao desatribuir ordem.',
        confirmButtonText: 'OK'
      });
      this.desatribuirOrder = null;
    });
  }

  // Modal / Ação: alterar status (disponível apenas para SuperAdministrador)
  showChangeStatusModal = false;
  changeTarget: any = null;
  changeSelectedStatus: string | null = null;
  changeMotivo: string | null = null;
  changeLoading: { [ordemId: string]: boolean } = {};

  openChangeStatusModal(ordem: any, event?: Event) {
    // debug log to verify click arrives
    event?.stopPropagation();
    if (!ordem) return;
    if (this.currentUserRole !== 'SuperAdministrador') {
      return;
    }
    this.changeTarget = ordem;
    this.changeSelectedStatus = ordem.status || null;
    this.changeMotivo = null;
    this.showChangeStatusModal = true;
    // close any action menu
    if (ordem._actionMenuOpen) ordem._actionMenuOpen = false;
  }

  closeChangeStatusModal() {
    this.showChangeStatusModal = false;
    this.changeTarget = null;
    this.changeSelectedStatus = null;
    this.changeMotivo = null;
  }

  confirmChangeStatus(): void {
    if (!this.changeTarget || !this.changeSelectedStatus) return;
    const ordem = this.changeTarget;
    const uiId = ordem.ordemServicoId || ordem.id || 'unknown';
    this.changeLoading[uiId] = true;
    this.spinner.show();

    const novoStatus = this.changeSelectedStatus;
    // helper to resolve cadastro/recadastro id from ordem payload
    const cadastroId = ordem.cadastroId ?? ordem.CadastroId ?? ordem.Cadastro?.id ?? ordem.CadastroId;
    const recadastroId = ordem.recadastroId ?? ordem.RecadastroId ?? ordem.Recadastro?.id ?? ordem.recadastroId;

    const finalizeSuccess = () => {
      this.changeLoading[uiId] = false;
      this.spinner.hide();
      // Close modal and reload current page from server so UI reflects authoritative status
      this.closeChangeStatusModal();
      try {
        // reload same page to reflect backend state
        this.loadPage(this.paginaAtual);
      } catch (e) {
        // fallback: reload window if loadPage not available for some reason
        console.error('Erro ao recarregar a página após alteração de status', e);
        // do not force full window reload in normal flow
      }
    };

    const finalizeError = (err?: any) => {
      console.error('Erro ao alterar status', err);

      try {
        if (err && err.error) console.error('Server error body:', err.error);
      } catch (_) {}
      this.changeLoading[uiId] = false;
      this.spinner.hide();
      const statusCode = err && err.status ? ` (${err.status})` : '';
      alert('Falha ao alterar o status' + statusCode + '. Verifique o console para mais detalhes.');
    };

    const statusCode = this.statusStringToCode(novoStatus);

    const handleError = (err: any) => finalizeError(err);

    if (novoStatus === 'Negada' || novoStatus === 'Negado') {
      const motivo = this.changeMotivo ? String(this.changeMotivo).trim() : '';
      if (!motivo || motivo.length < 10) {
        this.changeLoading[uiId] = false;
        this.spinner.hide();
        alert('Informe o motivo da negação com pelo menos 10 caracteres antes de confirmar.');
        return;
      }

      if (recadastroId) {
        this.servicoService.negarRecadastro(recadastroId, motivo)
          .pipe(
            switchMap(() => this.applyOrderStatusWithRetries(ordem.ordemServicoId, statusCode, novoStatus)),
            catchError(err => { handleError(err); return of(null); })
          )
          .subscribe({ next: () => finalizeSuccess(), error: err => finalizeError(err) });
        return;
      }

      if (cadastroId) {
        this.servicoService.negarCadastro(cadastroId, motivo)
          .pipe(
            switchMap(() => this.applyOrderStatusWithRetries(ordem.ordemServicoId, statusCode, novoStatus)),
            catchError(err => { handleError(err); return of(null); })
          )
          .subscribe({ next: () => finalizeSuccess(), error: err => finalizeError(err) });
        return;
      }

      this.changeLoading[uiId] = false;
      this.spinner.hide();
      alert('Não foi possível identificar se é cadastro ou recadastro. A operação não foi executada.');
      return;
    }

    // Tratamento especial: se o usuário escolheu 'Concluida', precisamos
    // marcar o cadastro/recadastro associado como 'Pendente' antes de alterar a OS.
    if (novoStatus === 'Concluida' || novoStatus === 'Concluído' || novoStatus === 'Concluída') {
      const targetCadastroStatus = 'Pendente';

      if (recadastroId) {
        this.servicoService.atualizarStatusRecadastro(recadastroId, targetCadastroStatus, undefined, undefined)
          .pipe(
            switchMap(() => this.applyOrderStatusWithRetries(ordem.ordemServicoId, statusCode, novoStatus)),
            catchError(err => { handleError(err); return of(null); })
          )
          .subscribe({ next: () => finalizeSuccess(), error: err => finalizeError(err) });
        return;
      }

      if (cadastroId) {
        this.servicoService.atualizarStatusCadastro(cadastroId, targetCadastroStatus, undefined, undefined)
          .pipe(
            switchMap(() => this.applyOrderStatusWithRetries(ordem.ordemServicoId, statusCode, novoStatus)),
            catchError(err => { handleError(err); return of(null); })
          )
          .subscribe({ next: () => finalizeSuccess(), error: err => finalizeError(err) });
        return;
      }

      this.changeLoading[uiId] = false;
      this.spinner.hide();
      alert('Não foi possível identificar se é cadastro ou recadastro. A operação não foi executada.');
      return;
    }

    // Outros status (Pendente, Ausente/Retornar, Concluida, etc): atualizar cadastro/recadastro primeiro e depois alterar status da ordem
    if (recadastroId) {
      this.servicoService.atualizarStatusRecadastro(recadastroId, novoStatus, undefined, undefined)
        .pipe(
          switchMap(() => this.applyOrderStatusWithRetries(ordem.ordemServicoId, statusCode, novoStatus)),
          catchError(err => { handleError(err); return of(null); })
        )
        .subscribe({ next: () => finalizeSuccess(), error: err => finalizeError(err) });
      return;
    }

    if (cadastroId) {
      this.servicoService.atualizarStatusCadastro(cadastroId, novoStatus, undefined, undefined)
        .pipe(
          switchMap(() => this.applyOrderStatusWithRetries(ordem.ordemServicoId, statusCode, novoStatus)),
          catchError(err => { handleError(err); return of(null); })
        )
        .subscribe({ next: () => finalizeSuccess(), error: err => finalizeError(err) });
      return;
    }

    alert('Não foi possível identificar se é cadastro ou recadastro. A operação não foi executada.');
    this.changeLoading[uiId] = false;
    this.spinner.hide();
  }

  onVer(ordem: any): void {
    if (!ordem || !ordem.ordemServicoId) return;
    const id = ordem.ordemServicoId;
    // bloquear botão e mostrar spinner
    this.viewLoading[id] = true;
    this.spinner.show();

    this.ordemServicoService.getOrdemServicoById(id).subscribe(res => {
      if (!res) {
        alert('Não foi possível carregar os detalhes.');
        this.viewLoading[id] = false;
        this.spinner.hide();
        return;
      }

      const queryParams: any = {};
      if (res.usuarioId) queryParams.usuarioId = res.usuarioId;

      // Se há idJuncao, usar para buscar detalhes (verificar diferentes formatos de nome)
      const idJuncao = res.idJuncao || res.IdJuncao || res.idjuncao || res.idJuncaoFk;
      if (idJuncao && idJuncao !== '00000000-0000-0000-0000-000000000000') {
        queryParams.idJuncao = idJuncao;
        this.servicoService.obterDetalhesporIdJuncao(idJuncao).subscribe(detalhes => {
          const dataEvento = detalhes?.dataHoraInicio || null;
          if (dataEvento) {
            const day = new Date(dataEvento).toISOString().split('T')[0];
            queryParams.filtroDataInicio = `${day}T00:00:00`;
            queryParams.filtroDataFim = `${day}T23:59:59`;
          }
          if (detalhes?.recadastroId || res.recadastroId) {
            queryParams.recadastroId = detalhes?.recadastroId || res.recadastroId;
          } else if (detalhes?.cadastroId || res.cadastroId) {
            queryParams.cadastroId = detalhes?.cadastroId || res.cadastroId;
          }
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams }).then(() => { this.viewLoading[id] = false; this.spinner.hide(); }).catch(() => { this.viewLoading[id] = false; this.spinner.hide(); });
          });
        }, err => {
          console.error('Erro ao buscar detalhes por idJuncao', err);
          // fallback: usar os ids originais se disponíveis
          if (res.recadastroId) queryParams.recadastroId = res.recadastroId;
          if (res.cadastroId) queryParams.cadastroId = res.cadastroId;
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams }).then(() => { this.viewLoading[id] = false; this.spinner.hide(); }).catch(() => { this.viewLoading[id] = false; this.spinner.hide(); });
          });
        });
        return;
      }

      // Fallback: If recadastroId present, fetch it to get the event date and navigate with a period centered on that date
      if (res.recadastroId && res.recadastroId !== '00000000-0000-0000-0000-000000000000') {
        this.servicoService.obterRecadastroPorId(res.recadastroId).subscribe(rc => {
          const dataEvento = rc?.dataHoraInicio || null;
          if (dataEvento) {
            const day = new Date(dataEvento).toISOString().split('T')[0];
            queryParams.filtroDataInicio = `${day}T00:00:00`;
            queryParams.filtroDataFim = `${day}T23:59:59`;
          }
          queryParams.recadastroId = res.recadastroId;
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams }).then(() => { this.viewLoading[id] = false; this.spinner.hide(); }).catch(() => { this.viewLoading[id] = false; this.spinner.hide(); });
          });
        }, err => {
          console.error('Erro ao buscar recadastro por id', err);
          // fallback: navigate with ids only
          queryParams.recadastroId = res.recadastroId;
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams }).then(() => { this.viewLoading[id] = false; this.spinner.hide(); }).catch(() => { this.viewLoading[id] = false; this.spinner.hide(); });
          });
        });
        return;
      }

      // Else if cadastroId present, fetch cadastro to get event date
      if (res.cadastroId && res.cadastroId !== '00000000-0000-0000-0000-000000000000') {
        this.servicoService.obterCadastroPorId(res.cadastroId).subscribe(cd => {
          const dataEvento = cd?.dataHoraInicio || null;
          if (dataEvento) {
            const day = new Date(dataEvento).toISOString().split('T')[0];
            queryParams.filtroDataInicio = `${day}T00:00:00`;
            queryParams.filtroDataFim = `${day}T23:59:59`;
          }
          queryParams.cadastroId = res.cadastroId;
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams }).then(() => this.viewLoading[id] = false).catch(() => this.viewLoading[id] = false);
          });
        }, err => {
          console.error('Erro ao buscar cadastro por id', err);
          queryParams.cadastroId = res.cadastroId;
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams }).then(() => this.viewLoading[id] = false).catch(() => this.viewLoading[id] = false);
          });
        });
        return;
      }

      // Se não houver datas específicas, passar o filtro atual da tela de ordens
      if (!queryParams.filtroDataInicio && this.filtroDataInicio) {
        queryParams.filtroDataInicio = this.filtroDataInicio;
      }
      if (!queryParams.filtroDataFim && this.filtroDataFim) {
        queryParams.filtroDataFim = this.filtroDataFim;
      }
      this.ngZone.run(() => {
        this.router.navigate(['/admin/roteiro-colaborador'], { queryParams }).then(() => { this.viewLoading[id] = false; this.spinner.hide(); }).catch(() => { this.viewLoading[id] = false; this.spinner.hide(); });
      });
    }, err => {
      console.error('Erro ao carregar ordem por id', err);
      alert('Não foi possível carregar os detalhes.');
      this.viewLoading[id] = false;
      this.spinner.hide();
    });
  }

  // Formata nome para exibir apenas nome + primeiro sobrenome
  formatarNomeVistoriante(nomeCompleto: string | null | undefined): string {
    if (!nomeCompleto || nomeCompleto.trim() === '') return '---';
    const partes = nomeCompleto.trim().split(' ');
    if (partes.length <= 1) return partes[0] || '---';
    // Retorna nome + primeiro sobrenome
    return `${partes[0]} ${partes[1]}`;
  }

}